if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.gallery-block__list').slick({
        accessibility: true,
        infinite:true,
        slidesToScroll: 4,
        arrows:true,
        variableWidth: true,
        slidesToShow: 4,
        prevArrow: $('.gallery-block__prev-arrow'),
        nextArrow: $('.gallery-block__next-arrow'),
        responsive: [
            //     {
            //     breakpoint: 1024,
            //     settings: {
            //       initialSlide:1,
            //       slidesToShow: 3,
            //       slidesToScroll: 3,
            //       variableWidth: false,
            //       infinite: true,
            //       dots: false
            //     }
            //   },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                accessibility: true,
                infinite:true,
                arrows:true,
                variableWidth: false
                
              }
            }
        ]
    });

    
    $('.sym-slider-block').slick({
        accessibility: false,
        arrows: true,
        dots: false,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow')
    });


    // nav form


    const lisNavForm = document.querySelectorAll(".form_nav__list ul li");

    lisNavForm.forEach((ele) => {
        ele.addEventListener('click', () => {
            // Eliminar la clase 'active' de todos los li
            lisNavForm.forEach(li => li.classList.remove('active'));
    
            // Agregar la clase 'active' al li que fue clickeado
            ele.classList.add('active');
    
            // Ocultar todos los formularios
            document.querySelectorAll('.switch-form').forEach(form => form.classList.add('hidden'));
    
            // Mostrar el formulario correspondiente
            document.querySelector(`#form-${ele.id}`).classList.remove('hidden');
        });
    });
    
    

    


})();